// import hooks
import { useTranslation } from "react-i18next";
import useWindowSize from "../../utils/custom-hooks/useWindowSize";
import { useState } from "react";

// import components
import { Form, Container, Row, Col } from "react-bootstrap";

// import assets
import "../../assets/css/cart.css";
import { redHeart } from "../../utils/cards-svgs";
import makeCountryAccounts from "../../utils/makeCountryAccounts";

// import data
import { cartList } from "../../utils/data/cartData";
import { stores } from "../../utils/flags";

// const  = cartList[0];

const CartItem = ({ item, key }) => {
    const windowWidth = useWindowSize();
    const [t, i18n] = useTranslation("global");
    // const [currency, setCurrency] = useState()
    const [quantity, setQuantity] = useState(item.quantity);

    const currency =
        i18n.language == "ar"
            ? stores.find((i) => i.name == item.selectedStore).ar.currency
            : stores.find((i) => i.name == item.selectedStore).en.currency;
    // console.log(stores.find(i=>i.name==item.selectedStore).ar.)
    const decreaseCount = () => {
        if (quantity > 1) {
            setQuantity(quantity - 1);
        }
    };
    return (
        <div className="cart-item product-section-div" key={key}>
            <Container>
                {windowWidth >= 992 ? (
                    <Row className="cart-item-row">
                        <Col lg={4}>
                            <img
                                src={item.img}
                                alt="image"
                                className="cart-item-image"
                            />
                        </Col>
                        <Col lg={6}>
                            <h3 className="cart-item-h">
                                {i18n.language == "ar"
                                    ? item.ar.name
                                    : item.en.name}
                            </h3>
                            <p className="cart-item-price-p ocean-p-grey">
                                {item.price} {currency}
                            </p>

                            <Row className="flex-between-row">
                                <div className="cart-item-quantity flex-start-row">
                                    <p>{t("cart.quant")}</p>

                                    <div className="counter-div">
                                        <div
                                            className="plus-btn"
                                            onClick={() =>
                                                setQuantity(quantity + 1)
                                            }
                                        >
                                            +
                                        </div>
                                        <div className="number">{quantity}</div>
                                        <div
                                            className="minus-btn"
                                            onClick={decreaseCount}
                                        >
                                            -
                                        </div>
                                    </div>
                                </div>
                            </Row>
                        </Col>
                        <Col lg={2}>
                            <div className="products-icon-div">
                                <div className="svg-circle">
                                    {item.wishList ? (
                                        <img
                                            src={redHeart}
                                            alt="heart icon"
                                            className="svg-image"
                                        />
                                    ) : (
                                        // <div className="heart-svg ocean-svg"></div>
                                        <div className="heart-svg ocean-svg"></div>
                                    )}
                                </div>

                                <div className="svg-circle">
                                    <div className="delete-svg ocean-svg "></div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                ) : (
                    // small view -------------------------------------
                    <>
                        <Row>
                            <Col sm={6}>
                                <img
                                    src={item.img}
                                    alt="image"
                                    className="cart-item-image"
                                />
                            </Col>
                            <Col sm={6}>
                                <h3 className="cart-item-h">
                                    {i18n.language == "ar"
                                        ? item.ar.name
                                        : item.en.name}
                                </h3>
                                <p className="cart-item-price-p">
                                    {item.price} {currency}
                                </p>
                            </Col>
                        </Row>
                        <div className="flex-between-row">
                            <div className="cart-item-quantity flex-start-row">
                                <p>{t("cart.quant")}</p>

                                <div className="counter-div">
                                    <div
                                        className="plus-btn"
                                        onClick={() =>
                                            setQuantity(quantity + 1)
                                        }
                                    >
                                        +
                                    </div>
                                    <div className="number">{quantity}</div>
                                    <div
                                        className="minus-btn"
                                        onClick={decreaseCount}
                                    >
                                        -
                                    </div>
                                </div>
                            </div>
                            <div className="products-icon-div">
                                <div className="svg-circle">
                                    {item.wishList ? (
                                        <img
                                            src={redHeart}
                                            alt="heart icon"
                                            className="svg-image"
                                        />
                                    ) : (
                                        <div className="heart-svg ocean-svg"></div>
                                    )}
                                </div>

                                <div className="svg-circle">
                                    <div className="delete-svg ocean-svg "></div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                <div
                    className={`cart-item-row ${
                        windowWidth >= 992 ? "flex-even-row" : ""
                    }`}
                >
                    <div className="cart-item-balance-div cart-item-sm-div flex-start-col">
                        <p className="cart-item-title-p">
                            {t("product.account-country")}
                        </p>
                        <Form.Select aria-label="Default select example">
                            <option>{t("product.account-country")}</option>
                            {makeCountryAccounts(
                                item.stores,
                                i18n.language
                            ).map((s) => (
                                <option
                                    value={s.country}
                                    className="store-account-sm"
                                    selected={
                                        s.country == item.selectedStore
                                            ? true
                                            : false
                                    }
                                >
                                    <img src={s.flag} alt="flag" />
                                    <span>{s.name}</span>
                                </option>
                            ))}
                        </Form.Select>
                    </div>

                    <div className="cart-item-balance-div cart-item-sm-div flex-start-col">
                        <p className="cart-item-title-p">
                            {t("product.card-balance")}
                        </p>
                        <Form.Select aria-label="Default select example">
                            <option>{t("product.card-balance")}</option>
                            {item.balance.map((b) => (
                                <option
                                    value={b}
                                    className="store-account-sm"
                                    selected={
                                        b == item.selectedBalance ? true : false
                                    }
                                >
                                    <span>
                                        {b} {t("product.currencies.dollar")}
                                    </span>
                                </option>
                            ))}
                        </Form.Select>
                    </div>

                    <div className="cart-item-id-div cart-item-sm-div flex-start-col">
                        <p className="cart-item-title-p">{t("product.id")}</p>
                        <input
                            type="text"
                            placeholder="1xxxxxxxxxx"
                            className="ocean-input"
                        />
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default CartItem;
